import {Component, Input} from '@angular/core';

@Component({
  templateUrl: './park-rain-diverter-controls.html',
  selector: 'park-rain-diverter-controls'
})

export class ParkRainDiverterControlsComponent {
  @Input() public rainDiverters: any;
  @Input() public parkId: any;
  @Input() public id: any;
  @Input() public color: string;
  objectKeys = Object.keys;
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/others/rain_diverter/park-rain-diverter-controls.component.ts